import React from "react";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate("/signup");
  };

  const handleEmailClick = () => {
    window.location.href = "mailto:ussasecretservice@gmail.com";
  };

  const footerLinks = [
    {
      title: "Most Wanted",
      links: [
        "Ten Most Wanted",
        "Fugitives",
        "Terrorism",
        "Kidnappings",
        "Seeking Information",
        "Bank Robbers",
        "ECAP",
        "ViCAP",
      ],
    },
    {
      title: "News",
      links: [
        "Stories",
        "Videos",
        "Press Releases",
        "Speeches",
        "Testimony",
        "Podcasts and Radio",
        "Photos",
        "Español",
        "Apps",
      ],
    },
    {
      title: "What We Investigate",
      links: [
        "Terrorism",
        "Counterintelligence",
        "Cyber Crime",
        "Public Corruption",
        "Civil Rights",
        "Organized Crime",
        "White-Collar Crime",
        "Violent Crime",
        "WMD",
      ],
    },
    {
      title: "Contact Us",
      links: [
        "Field Offices",
        "CIA Headquarters",
        "Overseas Offices",
        { text: "ussasecretservice@gmail.com", onClick: handleEmailClick },
      ],
    },
    {
      title: "Connect",
      links: [
        "Facebook",
        "Twitter",
        "Instagram",
        { text: "LinkedIn", onClick: handleNavigate },
      ],
    },
  ];

  return (
    <footer className="bg-black text-gray-300 py-8 md:py-16">
      <div className="container mx-auto px-6 lg:px-12">
        {/* Grid for footer links */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 text-center sm:text-left">
          {footerLinks.map((section, index) => (
            <div key={index} className="flex flex-col items-center sm:items-start">
              <h4 className="text-lg font-semibold text-white mb-4">{section.title}</h4>
              <ul className="space-y-2">
                {section.links.map((link, idx) => (
                  <li key={idx}>
                    {typeof link === "string" ? (
                      <button
                        className="hover:text-gray-100 transition duration-200 text-sm md:text-base"
                        onClick={() => {}}
                      >
                        {link}
                      </button>
                    ) : (
                      <button
                        onClick={link.onClick}
                        className="hover:text-gray-100 transition duration-200 text-sm md:text-base"
                      >
                        {link.text}
                      </button>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom section */}
        <div className="mt-8 md:mt-12 border-t border-gray-700 pt-6 flex flex-col items-center text-center">
          <p className="text-sm text-gray-500 mb-4 md:mb-0">
            © {new Date().getFullYear()} Crime Law Enforcement. All rights reserved.
          </p>
          <ul className="flex flex-col sm:flex-row sm:space-x-4 space-y-2 sm:space-y-0">
            {["Privacy Policy", "Terms of Service", "Contact"].map((item, index) => (
              <li key={index}>
                <button
                  className="text-gray-500 hover:text-gray-100 transition duration-200 text-sm"
                  onClick={() => {}}
                >
                  {item}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;